export default async function GetCitiesByStateId(data) {
    let url = window.RealestateService + "/api/StateCity/GetCitiesByStateId?stateId="+data;
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response;
}